module.exports = __webpack_public_path__ + "static/stone_giant_rune_scribe-d4dc0aee89d5ac3d2d911fe1f4cb2268.png";